import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOf } from './exploreContentResponsePageAllOfThreeContentItemContentOneOf';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreeseven } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfThreeseven';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezero } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezero';

/**
 * 콘텐츠 데이터 (타입에 따라 다른 형식)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContent = ExploreContentResponsePageAllOfThreeContentItemContentOneOf | ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreeseven | ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezero;
